import { Loader } from "./loader";

export const RootLoader = () => (
  <div className="fixed inset-0 grid place-items-center bg-background">
    <Loader />
  </div>
);
